'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
		indicatorClassName?: string
	}
>(({ className, indicatorClassName, ...props }, ref) => (
	<CheckboxPrimitive.Root
		className={cn(
			'peer border-foreground focus-visible:ring-ring data-[state=checked]:bg-foreground data-[state=checked]:text-primary-foreground size-[14px] shrink-0 rounded-[4px] border focus-visible:ring-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
			className,
		)}
		ref={ref}
		{...props}
	>
		<CheckboxPrimitive.Indicator
			className={cn(
				'border-background bg-foreground flex size-full items-center justify-center rounded-[4px] border text-current',
				indicatorClassName,
			)}
		/>
	</CheckboxPrimitive.Root>
))

Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
